export default "__VITE_ASSET__C3ljL50v__"